/* istanbul ignore file */
import styled from 'styled-components';

export const Link = styled.a`
  overflow-wrap: anywhere;
`;

interface TopUpLinkProps {
  hasTimeLeft: boolean;
}

export const TopUpLink = styled.a.attrs({
  rel: 'noreferrer',
})<TopUpLinkProps>`
  color: ${({ theme, hasTimeLeft }) => (hasTimeLeft ? theme.colorNeutralBlack : theme.colorPrimaryPrimary10)};
  font-weight: 900;
`;
